import { AxiosResponse } from 'axios';

export default {
  baseUrl: null,
  init(): Promise<AxiosResponse> {
    if (this.baseUrl !== null) {
      return this.baseUrl;
    }
    return new Promise((resolve) => {
      window.AP.getLocation((locationUrl) => {
        const url = new URL(locationUrl);
        this.baseUrl = url.origin;
        resolve(this.baseUrl);
      });
    });
  },
  getIssueDescriptionHost(): string {
    return this.baseUrl;
  },
};
